import { createReducer, on } from '@ngrx/store';
import { 
  TIP_FIND_SUCCESS,
  TIP_FAILED,
  TIP_UPDATE_LOADING,
  TIP_FIND_ALL_SUCCESS,
  TIP_DETAIL_FIND_SUCCESS,
  CART_CLEAR
 } from '../actions'
import { Tip, TipDetail } from '@core/models';
 
export interface TipState {
  loading: boolean;
  tipList: Tip[] | null;
  tip: Tip | null;
  error: string | null;
  tipDetail: TipDetail | null;
}

const initialState: TipState = {
  loading: false,
  tipList: null,
  error: null,
  tip: null,
  tipDetail: null
}

export const tipReducer = createReducer(
  initialState,
  on(TIP_FIND_SUCCESS, (state, { tip }) => ({ ...state, tip })),
  on(TIP_FIND_ALL_SUCCESS, (state, { tipList }) => ({ ...state, tipList })),
  on(TIP_FAILED, (state, { error }) => ({ ...state, error })),
  on(TIP_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(TIP_DETAIL_FIND_SUCCESS, (state, { tipDetail }) => ({ ...state, tipDetail })),
  on(CART_CLEAR, (state) => ({ ...state, tipDetail: null })),
);
